module.exports = __webpack_public_path__ + "img/slide-24.db8c6364.jpg";